import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("bz_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

export function formatError(err) {
    const detail = err?.response?.data?.detail;
    if (detail == null) return err?.message || "Something went wrong";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
    if (detail?.msg) return detail.msg;
    return String(detail);
}

export function fileUrl(fileId) {
    if (!fileId) return "";
    return `${API}/files/${fileId}`;
}

export default api;
